function initBrandHeroReveal(scope = document) {
  const thumbnails = scope.querySelectorAll('.brand-hero__thumbnail--reveal:not(.brand-hero__thumbnail--ready)');
  if (!thumbnails.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    thumbnails.forEach((thumbnail) => thumbnail.classList.add('brand-hero__thumbnail--ready'));
    return;
  }

  thumbnails.forEach((thumbnail) => {
    if (thumbnail.dataset.revealInit === 'true') return;
    thumbnail.dataset.revealInit = 'true';

    const image = thumbnail.querySelector('img');
    let revealed = false;

    const reveal = () => {
      if (revealed) return;
      revealed = true;
      clearTimeout(fallbackTimer);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          thumbnail.classList.add('brand-hero__thumbnail--ready');
        });
      });
    };

    const fallbackTimer = setTimeout(reveal, 350);

    if (!image || (image.complete && image.naturalWidth > 0)) {
      reveal();
      return;
    }

    image.addEventListener('load', reveal, { once: true });
    image.addEventListener('error', reveal, { once: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initBrandHeroReveal());
} else {
  initBrandHeroReveal();
}

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  document.querySelectorAll('.brand-hero__thumbnail--reveal').forEach((thumbnail) => {
    thumbnail.classList.add('brand-hero__thumbnail--ready');
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initBrandHeroReveal(event.target);
  });
}
